var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgChannels = function SvgChannels(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.496 2.522a.763.763 0 0 0-.524.943l3.878 14.474c.111.413.525.662.925.555.4-.108.635-.53.524-.943L14.421 3.077a.763.763 0 0 0-.925-.555ZM6 3.252a.75.75 0 0 1 1.5 0v14.5a.75.75 0 0 1-1.5 0v-14.5Zm3.273.258a.762.762 0 0 1 .525-.941c.4-.107.814.14.924.552l3.868 14.435a.762.762 0 0 1-.525.94.762.762 0 0 1-.924-.552L9.273 3.51ZM4 6.503v13.5h16v-13.5h1.5v15h-19v-15H4Z",
    fill: "currentColor"
  })));
};
export default SvgChannels;